import React from 'react';
import { Link } from 'react-router-dom';

export default () => {
  return(
  	<button ><Link to ="/products">Start Shop&#8594;</Link></button>
  	);
 }